// @core/api/endpoints/affiliate/get_campaign.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CampaignResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Get campaign by ID
 * Retrieves campaign by the specified identifier.
 */
export async function GetCampaign(
  campaign_id: string,
  options?: RequestOptions
): Promise<CampaignResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/campaigns/:campaign_id`;
  requestPath = requestPath.replace(':campaign_id', encodeURIComponent(campaign_id));
  const requestOptions = options;
  return client.get<CampaignResponse>(requestPath, { ...requestOptions });
}
